var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/address-form/phone.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n\n<div class=\"u-clearfix c-form__field is-required\">\n\n    <div class=\"g-address-payment__phone--form\">\n\n        <label for=\"address.phoneNumber\" class=\"c-form__label\">\n\n            ";
output += runtime.suppressValue((lineno = 8, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-phoneNum",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </label>\n\n        <input type=\"text\" name=\"address.phoneNumber\" id=\"address.phoneNumber\" value=\"";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup(((lineno = 12, colno = 97, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"address")),"phoneNumber"), env.opts.autoescape);
output += "\" class=\"js-address-form-item c-form__text\" pattern=\"^[0-9]+$\" maxlength=\"30\" required aria-required=\"true\" data-qa-address-form-phone-number aria-describedby=\"address.phoneNumber_error\" aria-labelledby=\"address-payment-phone_hint\" aria-labelledby=\"address-payment-phone_hint\"/>\n\n        <span class=\"c-form-message\" data-qa-error-field=\"phoneNumber\" id=\"address.phoneNumber_error\">\n\n            ";
output += runtime.suppressValue((lineno = 16, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_validations-phoneNumber",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </span>\n\n    </div>\n\n    <div class=\"g-address-payment__phone--form-hint\">\n\n        <div class=\"c-form-hint\">\n\n            <p class=\"c-form-hint__p\" id=\"address-payment-phone_hint\">\n\n               ";
output += runtime.suppressValue((lineno = 28, colno = 16, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-globalFormField-phoneValidation",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n            </p>\n\n        </div>\n\n    </div>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/address-form/phone.j2"] , dependencies)